/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header/Header";
import { useSearchParams } from "react-router-dom";
import { getWeeklyAddedUsers } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import { format } from "date-fns";
import { Button } from "@mui/material";
import GenerateNewUsers from "./GenerateNewUsers/GenerateNewUsers";
import { Modal } from "antd";

const WeeklyNewUsersTable = () => {
  const { state } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [date, setDate] = useState(null);
  const [week, setWeek] = useState<any>(searchParams.get("week") || 1);
  const [year, setYear] = useState<any>(searchParams.get("year") || 2024);
  const [workersList, setWorkersList] = useState<any>([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const getWorkersList = async () => {
    try {
      const response = await getWeeklyAddedUsers(state.user?.token, week, year);
      setWorkersList(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const columns = [
    {
      field: "fullName",
      headerName: "Full Name",
      flex: 1,
      renderCell: (params: any) => (
        <div>
          {params.row.name} {params.row.surname}
        </div>
      ),
    },
    {
      field: "pts",
      headerName: "PTS",
      flex: 1,
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
    },
    {
      field: "postCode",
      headerName: "Post Code",
      flex: 1,
    },
    {
      field: "Created Date",
      headerName: "Created Date",
      flex: 1,
      renderCell: (params: any) => (
        <div>{format(new Date(params.row.createdDate), "dd/MM/yyyy")}</div>
      ),
    },
    {
      field: "Created By",
      headerName: "Created By",
      flex: 1,
      renderCell: (params: any) => (
        <>
          {params.row.createdBy?.name
            ? `${params.row.createdBy?.name} ${params.row.createdBy?.surname}`
            : "Not Specified"}
        </>
      ),
    },
  ];

  useEffect(() => {
    setSearchParams({ year, week }, { replace: true });
    getWorkersList();
  }, [date]);

  return (
    <>
      <Header
        setDate={setDate}
        week={week}
        setWeek={setWeek}
        year={year}
        setYear={setYear}
      />
      <Box
        marginTop={12}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          mr: 22,
        }}
      >
        <Button
          variant="contained"
          onClick={() => setIsDialogOpen(true)}
          style={{ boxShadow: 'none' }}
        >
          Generate Users Report
        </Button>
      </Box>
      <Box
        sx={{ height: "850px", width: "80%" }}
        marginTop={2}
        marginLeft={25}
      >
        <DataGrid
          rows={workersList}
          columns={columns}
          disableRowSelectionOnClick
          sx={{
            "@media (max-width: 700px)": {
              minWidth: "100%",
            },
            "& .MuiDataGrid-columnHeader": {
              color: "#333",
              fontWeight: "bold",
              fontSize: 15,
              backgroundColor: "#f0f0f0",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
            "@media (max-width: 600px)": {
              fontSize: "0.7rem",
            },
          }}
        />
      </Box>
      <Modal
        title={`Users Report`}
        open={isDialogOpen}
        onClose={handleDialogClose}
        onCancel={() => setIsDialogOpen(false)}
        destroyOnClose
        footer={[]}
      >
        <GenerateNewUsers week={week} year={year} />
      </Modal>
    </>
  );
};

export default WeeklyNewUsersTable;
